module.exports = __webpack_public_path__ + "img/product.3d4487a4.jpg";